<template>
  <div>health page</div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'empty-p',
})
</script>

<style scoped></style>
